import React from 'react'
import { clsx } from 'clsx'

export interface TelemetryDatum {
  label: string
  value: string | number
  status?: 'nominal' | 'warning' | 'critical' | 'sovereign'
}

interface GlassOverlayProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  variant?: 'default' | 'chat' | 'portal' | 'hud' | 'titan' | 'sovereign' | 'boot'
  visible?: boolean
  /** Live telemetry data strip rendered below content */
  telemetry?: TelemetryDatum[]
  /** Show corner bracket HUD decoration */
  brackets?: boolean
}

export const GlassOverlay: React.FC<GlassOverlayProps> = ({
  children,
  className,
  style,
  variant = 'default',
  visible = true,
  telemetry,
  brackets = false
}) => {
  if (!visible) {
    return null
  }

  const showBrackets = brackets || variant === 'sovereign' || variant === 'boot'

  return (
    <div
      className={clsx('glass-overlay', className)}
      data-variant={variant}
      style={{ ...style }}
    >
      {/* Sovereignty pulse border — CSS-only animation */}
      {variant === 'sovereign' && <div className="sovereignty-border-pulse" />}

      {/* Corner bracket HUD decoration */}
      {showBrackets && (
        <>
          <span className="glass-bracket tl" />
          <span className="glass-bracket tr" />
          <span className="glass-bracket bl" />
          <span className="glass-bracket br" />
        </>
      )}

      {children}

      {/* Telemetry strip — real data only */}
      {telemetry && telemetry.length > 0 && (
        <div className="telemetry-strip">
          {telemetry.map((d, i) => (
            <span key={i} className={clsx('telemetry-cell', d.status && `ts-${d.status}`)}>
              <span className="telemetry-label">{d.label}</span>
              <span className="telemetry-value">{d.value}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default GlassOverlay
